<template>
  <div class="zhenyun-theme full-page">
    <div class="sticky-position">
      <SearchHeader v-model="queryParams.keyword" @handleSearch="handleSearch">
        <template #left>
          <customTab
            :tabList="headerFilterList"
            v-model="currentTab"
            @change="changeTab"
          >
          </customTab>
        </template>
      </SearchHeader>
      <div class="filter-selected">
        <div class="diy-form-box">
          <div class="form-item">
            <span class="label">报价日期</span>
            <el-date-picker
              v-model="datePickerValue"
              type="daterange"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="handleDatePickerChange"
              clearable
            >
            </el-date-picker>
          </div>
          <div class="form-item">
            <el-select
              v-model="queryParams.status"
              placeholder="报价状态"
              @change="changeStatusTab"
              clearable
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-show="item.value != 1"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="quote-table-box">
      <quoteTable :sourceData="tableList" ref="quoteTableRef"></quoteTable>
    </div>
    <div class="pagination-box">
      <span class="total-number">共{{ pageTotal }}项数据</span>
      <div class="pagination-right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.curPage"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="sizes, prev, pager, next"
          :total="pageTotal"
        >
        </el-pagination>
        <div class="h-jump-page">
          跳至
          <el-input-number
            v-model="queryParams.curPage"
            @change="inputChange"
            @blur="inputBlur"
            style="width: 60px"
            :controls="false"
            size="mini"
            @keyup.enter.native="handleEnter"
            :min="1"
            :max="totalPage"
          ></el-input-number
          >/ {{ totalPage }} 页
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import SearchHeader from '@/components/zhenyunComponents/search-header'
import customTab from '@/components/zhenyunComponents/custom-tab.vue'
import quoteTable from './components/quote-table.vue'
import {
  getMyQuoteListApi,
  getMyQuoteStatusNumberApi,
  getContactInfoApi,
  getDraftListApi,
} from '@/utils/api/zhenyun.js'
import { getSingleDictByType } from '@/utils/api/common.js'
import Big from 'big.js'
export default {
  name: 'quote-list',
  props: [],
  components: {
    SearchHeader,
    customTab,
    quoteTable,
  },
  data() {
    return {
      totalPage: 0,
      currentTab: '0',
      headerFilterList: [
        {
          label: '我的报价（0）',
          value: 'totalQuotes',
        },
        {
          label: '已候选（0）',
          value: 'candidate',
        },
        {
          label: '已接受（0）',
          value: 'accepted',
        },
        {
          label: '已拒绝（0）',
          value: 'rejected',
        },
        {
          label: '草稿箱（0）',
          value: 'rejected',
          icon: 'icon-caogaoxiang',
        },
      ],
      statusList: [],
      datePickerValue: '',
      queryParams: {
        status: '',
        keyword: '',
        quoteTimeEnd: '',
        quoteTimeStart: '',
        status: '',
        curPage: 1,
        pageSize: 20,
      },
      tableList: [],
      pageTotal: 0,
      hasChanged: false, // 标记值是否已变化
      tabValue:''
    }
  },
  methods: {
    scrollToTop() {
      const container =
        document.querySelector('.el-scrollbar-wrap') ||
        document.documentElement ||
        document.body
      console.log(container, 'container')
      container.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    handleEnter() {
      this.fetchList()
      this.scrollToTop()
    },
    inputBlur() {
      if (this.hasChanged) {
        this.hasChanged = false
        this.fetchList()
        this.scrollToTop()
      }
    },
    inputChange(evt) {
      this.hasChanged = true
    },
    handleSizeChange(page) {
      this.queryParams.pageSize = page
      this.queryParams.curPage = 1 // 重置页码为第一页
      this.fetchList()
      this.scrollToTop()
    },
    handleCurrentChange(page) {
      this.queryParams.pageSize = 20
      this.queryParams.curPage = page
      this.fetchList()
      this.scrollToTop()
    },
    changeTab(tab) {
      this.queryParams.curPage = 1 // 重置页码为第一页
      this.queryParams.status = undefined
      this.tabValue = tab == '0' ? '' : tab
      if (tab == 1) {
        this.fetchList({ status: undefined }, getDraftListApi)
        return
      }
      this.fetchList({ status: tab == '0' ? '' : tab })
    },
    changeStatusTab(tabValue) {
      this.currentTab = '0'
      this.tabValue = ''
      this.queryParams.curPage = 1 // 重置页码为第一页
      this.fetchList({ status: tabValue })
    },
    handleDatePickerChange(value) {
      this.queryParams.curPage = 1 // 重置页码为第一页
      if (!value) {
        this.queryParams.quoteTimeStart = ''
        this.queryParams.quoteTimeEnd = ''
      } else {
        let start = moment(value[0]).format('YYYY-MM-DD 00:00:00')
        let end = moment(value[1]).format('YYYY-MM-DD 23:59:59')
        this.queryParams.quoteTimeStart = new Date(start).valueOf()
        this.queryParams.quoteTimeEnd = new Date(end).valueOf()
      }
      this.fetchList()
    },
    async fetchList(query = {}, draftApi = undefined) {
      try {
        this.$refs.quoteTableRef.tableLoading = true
        const apiType = (draftApi || this.tabValue ==1 )  ? getDraftListApi : getMyQuoteListApi
        const copyQuery = { ...this.queryParams }
        if(!draftApi){
          copyQuery.status = this.tabValue || query.status || this.queryParams.status
        }
        const res = await apiType({ ...copyQuery, ...query })
        this.$refs.quoteTableRef.tableLoading = false
        const { rspResult, rspPageData } = res

        if (rspResult.bizCode == 200) {
          this.tableList = rspPageData.list.map((k) => {
            const amount = new Big(k.totalAmount || 0)
            k.totalAmountStr = amount.eq(0)
              ? `${k.symbol || ''}0`
              : `${k.symbol || ''}${amount
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
            return k
          })
          this.pageTotal = rspPageData.totalNum
          this.totalPage = rspPageData.totalPage
        }
      } catch (error) {
        this.$refs.quoteTableRef.tableLoading = false
      }
    },
    fetchStatusList() {
      getSingleDictByType('quotestatus').then((res) => {
        if (res.rspResult.bizCode == 200) {
          this.statusList = (res.rspListData.list || []).map((k) => {
            return {
              label: k.name,
              value: k.codeValue,
            }
          })
        }
      })
    },
    async fetchQuoteStatusNumner() {
      try {
        const res = await getMyQuoteStatusNumberApi()
        const { rspResult, data } = res
        if (rspResult.bizCode == 200) {
          const {
            accepted: acceptedCount = 0,
            candidate: candidateCount = 0,
            rejected: rejectedCount = 0,
            totalQuotes: totalCount = 0,
            draft: draftCount = 0,
          } = data || {}
          this.headerFilterList = [
            { label: `我的报价（${totalCount || 0}）`, value: '0' },
            { label: `已候选（${candidateCount || 0}）`, value: '7' },
            { label: `已接受（${acceptedCount || 0}）`, value: '8' },
            { label: `已拒绝（${rejectedCount || 0}）`, value: '3' },
            {
              label: `草稿箱（${draftCount || 0}）`,
              value: '1',
              icon: 'icon-caogaoxiang',
            },
          ]
        }
      } catch (error) {}
    },
    handleChangeTab(tab) {
      this.currentTab = tab.value
    },
    handleSearch() {
      this.queryParams.curPage = 1 // 重置页码为第一页
      this.fetchList({status: this.tabValue|| this.queryParams.status })
    },
    handleSearch1() {
      this.queryParams.status = 1
      this.fetchList()
    },
  },
  mounted() {
    this.fetchList()
    this.fetchStatusList()
    this.fetchQuoteStatusNumner()
  },
}
</script>
<style lang="scss" scoped>
.full-page {
  font-family: SourceHanSansCN-Regular;
}
.filter-selected {
  padding: 16px 24px;
  .diy-form-box {
    display: flex;
    align-items: center;
    gap: 24px;
    .form-item {
      .label {
        display: inline-block;
        color: #333333;
        text-overflow: ellipsis;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-right: 8px;
      }
    }
  }
}
.quote-table-box {
  background: #fff;
  padding: 16px;
  margin: 0 12px;
}
.pagination-box {
  padding: 16px 24px;
  background: #fff;
  margin: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .total-number {
    color: #555555;
    font-size: 14px;
    line-height: 22px;
  }
  .pagination-right {
    display: flex;
    align-items: center;
  }
  .h-jump-page {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #555555;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    padding: 5px 8px;
    background: #f5f7fa;
  }
}
.sticky-position {
  position: sticky;
  top: 0;
  z-index: 6;
  background: #f5f7fa;
}
.customTabItemBox {
  padding-left: 24px;
}
.customTabItemBox::after {
  content: '';
  display: inline-block;
  width: 1px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 2px;
  background: #98a3b7;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -8px;
}
</style>
